module.exports = __webpack_public_path__ + "img/logo_diagnostico_ambos.f745f0f4.jpg";